import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b51e2672")

_pushScopeId("data-v-b51e2672")
const _hoisted_1 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_2 = { class: "flex-grow flex flex-col px-4 pt-6 overflow-y-scroll" }
const _hoisted_3 = { class: "flex flex-row mb-4" }
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("TODOを追加")
const _hoisted_6 = { class: "flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("エクスポート")
const _hoisted_8 = { class: "flex flex-col mb-8" }
const _hoisted_9 = { class: "w-full flex flex-row justify-between py-4 px-6 bg-gray-200" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h2", { class: "w-1/3 text-center font-bold text-xl" }, "名称", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 作成日 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" チェック日 ")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "w-12 px-3 py-3 " }, null, -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "w-1/3 text-center" }
const _hoisted_16 = { class: "w-1/3 text-center" }
const _hoisted_17 = { class: "w-1/3 text-center" }
const _hoisted_18 = { class: "w-12 px-3 py-3 flex text-gray-400" }
const _hoisted_19 = {
  key: 0,
  class: "flex flex-shrink-0 justify-center py-4"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 1,
  class: "mt-10 text-center"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MSPanelHeader = _resolveComponent("MSPanelHeader")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_MSPanelHeader, { "select-page": "todo" }),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (
            (_ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool || _ctx.isEmployeeOfSchool) &&
              _ctx.canEditStudent
          )
            ? (_openBlock(), _createBlock(_component_m_button, {
                key: 0,
                class: "mr-2",
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.openTodoAddModal
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_4, [
                    _createVNode(_component_m_icon, {
                      type: "plus",
                      width: "2"
                    }),
                    _hoisted_5
                  ])
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool || _ctx.isEmployeeOfSchool)
            ? (_openBlock(), _createBlock(_component_m_button, {
                key: 1,
                color: "primary-500",
                "hover-color": "primary-600",
                onClick: _ctx.exportTodos
              }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_m_icon, {
                      type: "plus",
                      width: "2"
                    }),
                    _hoisted_7
                  ])
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("section", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("h2", {
              class: "w-1/3 flex flex-row justify-center items-center gap-1 font-bold text-xl",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSortOrder('createdAt')))
            }, [
              _hoisted_11,
              _createVNode(_component_m_icon, {
                class: ["cursor-pointer", [
                !_ctx.isDesc && _ctx.sortKey === 'createdAt'
                  ? 'transform rotate-180'
                  : '',
                _ctx.sortKey !== 'createdAt' ? 'text-gray-500' : ''
              ]],
                width: 4,
                type: "chevron-down"
              }, null, 8, ["class"])
            ]),
            _createVNode("h2", {
              class: "w-1/3 flex flex-row justify-center items-center gap-1 font-bold text-xl",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSortOrder('checkedAt')))
            }, [
              _hoisted_12,
              _createVNode(_component_m_icon, {
                class: ["cursor-pointer", [
                !_ctx.isDesc && _ctx.sortKey === 'checkedAt'
                  ? 'transform rotate-180'
                  : '',
                _ctx.sortKey !== 'checkedAt' ? 'text-gray-500' : ''
              ]],
                width: 4,
                type: "chevron-down"
              }, null, 8, ["class"])
            ]),
            _hoisted_13
          ]),
          (_ctx.sortedTodos.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedTodos, (todo) => {
                  return (_openBlock(), _createBlock("div", {
                    key: todo.title,
                    class: "w-full flex flex-row justify-between items-center px-4 py-2 border-b border-gray-400"
                  }, [
                    _createVNode("div", _hoisted_15, _toDisplayString(todo.title), 1),
                    _createVNode("div", _hoisted_16, _toDisplayString(todo.createdAt), 1),
                    _createVNode("div", _hoisted_17, _toDisplayString(todo.checkedAt), 1),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", {
                        class: "p-1 rounded-md cursor-pointer hover:bg-gray-100",
                        onClick: _withModifiers(($event: any) => (_ctx.select(todo)), ["prevent"])
                      }, [
                        _createVNode(_component_m_icon, { type: "pencil" })
                      ], 8, ["onClick"])
                    ])
                  ]))
                }), 128)),
                (!_ctx.todosFinished)
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode("div", {
                        class: "px-4 py-2 rounded-md text-gray-700 text-sm underline transition-colors duration-300 cursor-pointer hover:bg-gray-100",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getMoreTodos && _ctx.getMoreTodos(...args)))
                      }, [
                        (!_ctx.moreTodosLoading)
                          ? (_openBlock(), _createBlock("span", _hoisted_20, "さらに読み込む"))
                          : _createCommentVNode("", true),
                        (_ctx.moreTodosLoading)
                          ? (_openBlock(), _createBlock("span", _hoisted_21, "読み込み中..."))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_22, _toDisplayString(_ctx.loading ? "TODO取得中..." : "TODOがありません。"), 1))
        ])
      ])
    ])
  ], 64))
})